import React from 'react';
import { useEffect, useState } from 'react';
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, IconButton } from '@mui/material';
import UserPicker from './UserPicker';
import AddIcon from '@mui/icons-material/Add';
import UserDetailsDialog from './UserDetailsDialog';

const OrganizationForm = ({ inputEntity, onChange, simpleMode = null }) => {

    const [entity, setEntity] = useState({ name: '', description: '', status: 'ACTIVE', type: '', primary_contact: '' });
    const [newUserDetailsDialogUser, setNewUserDetailsDialogUser] = useState(null)
    const [isUserDetailsDialogOpen, setIsUserDetailsDialogOpen] = useState(null)

        
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onChange({
            ...entity,
            [name]: value
        });
    };

    const handleAddNewUser = (e, newUser) => {
        console.dir(newUser)
        setIsUserDetailsDialogOpen(false);
        let name="primary_contact";
        let value=newUser.id;
        onChange({
            ...entity,
            [name]: value
        });

    }

    const handleAddExistingUser = (user_id, user) => {
        let name="primary_contact";
        let value=user_id;
        onChange({
            ...entity,
            [name]: value
        });
    }

    const openAddUserDialog = () => {
        const newUser = { username: '', email: '', first_name: '', last_name: '', type: 'depositor' };
        setNewUserDetailsDialogUser(newUser);
        setIsUserDetailsDialogOpen(true);
    }

    const closeAddUserDialog = (entity) => {
        setIsUserDetailsDialogOpen(false);
        setNewUserDetailsDialogUser(null);
        console.dir("closeAddUserDialog")
        console.dir(entity)
    }

    useEffect(() => {
        console.dir("use effect called in organization forms.")
        console.dir(inputEntity)
        if (inputEntity != null) {
            setEntity(inputEntity);
        }
    }, [inputEntity]);


    return (
        <div>
            <Grid container spacing={2} padding={1}>
                <Grid item xs={6}>
                    <FormControl className="styled-form-control" fullWidth>
                        <TextField
                            id="name"
                            name="name"
                            label={"Name"}
                            variant="outlined"
                            fullWidth
                            value={entity.name || ''}
                            onChange={handleInputChange}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={5}>
                    <UserPicker onSelect={handleAddExistingUser} orgIdFilter={null} inputUserId={entity.primary_contact} pickerTitle='Please Select A Priamry Contact'/>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        style={{
                            backgroundColor: '#e0e0e0',
                            borderRadius: '4px',
                            padding: '16px',
                        }}
                        onClick={openAddUserDialog}
                    >
                        <AddIcon style={{ color: '#6200ea' }} />
                    </IconButton>
                </Grid>

                {simpleMode == false && (
                    <Grid item xs={6}>
                        <FormControl variant="outlined" className="styled-form-control" fullWidth>
                            <InputLabel id="organization_type">Organization Type</InputLabel>
                            <Select
                                labelId="organization_type"
                                id="organization_type"
                                name="organization_type"
                                value={entity.organization_type || ''}
                                onChange={handleInputChange}
                                label="Organization Type"
                            >
                                <MenuItem value="" disabled>
                                    Please Select A Type
                                </MenuItem>
                                <MenuItem value="Assay Provider">Assay Provider</MenuItem>
                                <MenuItem value="Research Group">Research Group</MenuItem>
                                <MenuItem value="Shadowstream">ShadowStream Administration</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                )}


            </Grid>
            <UserDetailsDialog showOrganization={false} inputEntity={newUserDetailsDialogUser} open={isUserDetailsDialogOpen} onClose={closeAddUserDialog} onSubmit={handleAddNewUser} />
        </div>

    );
};

export default OrganizationForm;
